import * as React from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import ScreenNameType from "@navigation/nav-screens";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ConfirmOTP from "app/shared/components/otp/otp";
import { ServiceCode } from "app/shared/services/api-path";
import { fetchTermDepositStatementAuthorizationRequest, setTermStatementStore } from "../reducer/actions";
import { getTermDepositStatementSelector } from "../reducer/selectors";
import { pushAppFlyer, pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

const TermDepositStatementAuth = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => {
        eventPushCleverTap(false);
        dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
      },
    },
    {
      name: t("SAVING_MO_SO"),
      onPressSubtitle: () => {},
    },
  ];
  /// MARK: - ACTION

  const termDepositStore = useSelector(getTermDepositStatementSelector);
  const contactId = useSelector(getContactIdSelector);

  const eventPushCleverTap = (status: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onPressCancel = () => {
    const { eventName, params } = handlerParamsAppFlyer(false);
    pushAppFlyer(eventName, params);
    eventPushCleverTap(false);
    dispatchStore(setTermStatementStore({ ...termDepositStore, isCreated: false, isConfirm: false, errorOTP: false }));
    dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE, { resetData: true }));
  };

  const onSubmit = ({ otpCode = "" }) => {
    eventPushCleverTap(true);
    dispatchStore(fetchTermDepositStatementAuthorizationRequest(termDepositStore.responseConfirm, otpCode));
  };

  const handlerParamsAppFlyer = (success: boolean) => {
    console.log("handlerParamsAppFlyer");
    let term = termDepositStore.dataCreate?.ACCOUNT_DEBIT?.FDTERM || "";
    if (term !== "") {
      term = term.replace("-", "");
    }
    const param = {
      product: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.PRODUCTCODE,
      term: term,
      amount: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.CURRENTBALANCE,
      branch: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE,
    };

    const paramStatus = {
      success: success,
      failure: !success,
    };

    return {
      eventName: "af_settlement_deposit",
      params: {
        af_channel: "ib_rb",
        af_settlement_deposit_info: JSON.stringify(param),
        af_settlement_deposit_status: JSON.stringify(paramStatus),
      },
    };
  };

  const handlerParamsCleverTap = (status: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let term = termDepositStore.dataCreate?.ACCOUNT_DEBIT?.FDTERM || "";
    if (term !== "") {
      term = term.replace("-", "");
    }
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: status ? "Tiếp tục" : "Quay lại",
      ct_final_settlement_product: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.PRODUCTCODE,
      ct_final_settlement_term: term,
      ct_final_settlement_total_amount: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.CURRENTBALANCE || "",
      ct_final_settlement_branch: termDepositStore.dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE || "",
      ct_final_settlement_interest_receive: termDepositStore?.responseCreate?.EBACCOUNT_DEPOSITS?.INTEREST_AMOUNT || "",
      ct_transaction_session: termDepositStore.responseConfirm?.EBACCOUNT_DEPOSITS?.RQSTSEQ || "",
      ct_transaction_code: termDepositStore.responseConfirm?.CHALLENGE_ID || "",
    };
    if (response) {
      param = {
        ...param,
        ct_final_settlement_status: response || "",
      };
    }

    return {
      eventNameCT: "ct_final_settlement_validate",
      paramsCT: param,
    };
  };

  React.useEffect(() => {
    if (termDepositStore.isAuthorization) {
      const { eventName, params } = handlerParamsAppFlyer(true);
      pushAppFlyer(eventName, params);
      eventPushCleverTap(true, "success");
      dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_STATEMENT_SUCCESS));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, termDepositStore.isAuthorization]);

  React.useEffect(() => {
    if (termDepositStore.errorOTP === true) {
      const { eventName, params } = handlerParamsAppFlyer(false);
      pushAppFlyer(eventName, params);
      eventPushCleverTap(true, "failure" + (termDepositStore.errorMsg || ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termDepositStore.errorOTP]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_MO_SO")} subtitles={subtitlesArrays} />
        <StepProcessUniversal currentSteps={2} />
        <ConfirmOTP
          goBack={onPressCancel}
          onSubmit={onSubmit}
          data={termDepositStore.responseConfirm}
          serviceCode={ServiceCode.TERM_DEPOSIT_STATEMENT}
          isReset={termDepositStore.isAuthorization}
          errorEndOTP={termDepositStore.errorOTP}
        />
      </ScrollView>
    </Block>
  );
};

export default TermDepositStatementAuth;
